// dependencies
import React from "react";
import { List } from "immutable";
import { format } from "date-fns";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import Request from "Components/Request";
import Spinner from "Components/Spinner";
import Paginator from "Components/Paginator";

// actions
import { updateRequestsPage } from "../../actions";

// selectors
import { getIsRequesting } from "Selectors/app";
import {
	getPagesize,
	graphSelectionRange,
	getGraphSelectionRequests,
	getEnvironmentRequestCount,
	getGraphSelectionCurrentPage,
} from "../../selectors";

// css
import css from "./GraphSelection.styl";

class GraphSelection extends React.PureComponent {
	static propTypes = {
		isRequesting: PropTypes.bool.isRequired,
		updateRequestsPage: PropTypes.func.isRequired,
		requestsTotalCount: PropTypes.number.isRequired,
		requestsCurrentPage: PropTypes.number.isRequired,
		pageSize: PropTypes.number.isRequired,
		requestsList: PropTypes.instanceOf(List).isRequired,
		selectionRange: PropTypes.instanceOf(List).isRequired,
	};

	componentDidMount = () => {};

	changePage = (page) => {
		this.props.updateRequestsPage(page);
	};

	render = () => {
		const { isRequesting, selectionRange, requestsList, requestsTotalCount, requestsCurrentPage, pageSize } =
			this.props;
		const pageCount = Math.ceil(requestsTotalCount / pageSize);

		if (selectionRange.size < 2) {
			return null;
		}

		const endTime = new Date(selectionRange.get(1) * 1000);
		const startTime = new Date(selectionRange.get(0) * 1000);

		return (
			<div className={css.SelectionContainer}>
				<div className={css.selectionInfo}>
					<div className={css.selectionCount}>Viewing {requestsTotalCount} Requests</div>
					<div className={css.selectionRange}>{`From ${format(startTime, "MMM d h:mm a")} to ${format(
						endTime,
						"MMM d h:mm a"
					)}`}</div>
				</div>

				{isRequesting && requestsTotalCount === 0 ? (
					<Spinner centered />
				) : (
					<div style={{ opacity: isRequesting ? 0.25 : 1 }} className={css.requestsWrapper}>
						{requestsList.map((request) => (
							<Request key={request.get("id")} request={request} />
						))}
					</div>
				)}

				<div className={css.paginatorWrapper}>
					<Paginator
						isRequesting={isRequesting}
						onClick={this.changePage}
						pageCount={pageCount}
						currentPage={requestsCurrentPage}
					/>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	pageSize: getPagesize(state),
	selectionRange: graphSelectionRange(state),
	requestsList: getGraphSelectionRequests(state),
	requestsTotalCount: getEnvironmentRequestCount(state),
	requestsCurrentPage: getGraphSelectionCurrentPage(state),
	isRequesting: getIsRequesting(state, "REQUESTS:GET"),
});

const mapDispatchToProps = (dispatch) => ({
	updateRequestsPage: (page) => dispatch(updateRequestsPage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphSelection);
